"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function StorageV2Icon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m18.18,22.695H5.82c-1.631,0-2.958-1.184-2.958-2.64V3.944c0-1.456,1.327-2.64,2.958-2.64h9.299l6.021,3.857v14.894c0,1.456-1.327,2.64-2.959,2.64ZM5.82,3.004c-.682,0-1.259.431-1.259.94v16.111c0,.51.577.94,1.259.94h12.36c.683,0,1.26-.431,1.26-.94V6.092l-4.819-3.088H5.82Z" }),
        react_1.default.createElement("rect", { x: "6.135", y: "4.614", width: "1.699", height: "7.772" }),
        react_1.default.createElement("rect", { x: "9.479", y: "4.614", width: "1.699", height: "7.772" }),
        react_1.default.createElement("rect", { x: "12.822", y: "4.614", width: "1.699", height: "7.772" }),
        react_1.default.createElement("rect", { x: "16.165", y: "7.84", width: "1.699", height: "4.547" }),
        react_1.default.createElement("rect", { x: "6.135", y: "13.842", width: "1.699", height: "1.471" }),
        react_1.default.createElement("rect", { x: "9.479", y: "13.842", width: "1.699", height: "1.471" }),
        react_1.default.createElement("rect", { x: "12.822", y: "13.842", width: "1.699", height: "1.471" }),
        react_1.default.createElement("rect", { x: "16.165", y: "13.842", width: "1.699", height: "1.471" })));
}
exports.default = StorageV2Icon;
